<template>
  <section class="nosotros mt-4">
    <!-- Qué es -->
    <div class="main row justify-content-center mx-0">
      <div class="col-6 col-xl-auto order-md-2 px-4 px-lg-5">
        <!-- eslint-disable -->
        <svg
          id="logo-amii"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
          xmlns:cc="http://creativecommons.org/ns#"
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:svg="http://www.w3.org/2000/svg"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
          xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
          xml:space="preserve"
          width="250mm"
          height="190mm"
          viewBox="0 0 250.00001 152"
          version="1.1"
          sodipodi:docname="logo_amii_250x190mm.svg"
          inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
        >
          <metadata id="metadata17">
            <rdf:RDF>
              <cc:Work rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
              </cc:Work>
            </rdf:RDF>
          </metadata>
          <sodipodi:namedview
            id="namedview15"
            pagecolor="#ffffff"
            bordercolor="#666666"
            borderopacity="1"
            objecttolerance="10"
            gridtolerance="10"
            guidetolerance="10"
            inkscape:pageopacity="0"
            inkscape:pageshadow="2"
            inkscape:window-width="1920"
            inkscape:window-height="1043"
            showgrid="false"
            inkscape:zoom="0.55273973"
            inkscape:cx="270.27005"
            inkscape:cy="270.89198"
            inkscape:window-x="0"
            inkscape:window-y="0"
            inkscape:window-maximized="1"
            inkscape:current-layer="svg13"
          />
          <g
            id="g11"
            transform="translate(-14.078742,-36.541218)"
          >
            <path
              id="nube"
              class="fil0 str0"
              d="M 80.3645,51.4333 C 84.3482,19.1951 36.4712,12.0139
                27.2943,46.8105 c -1.4216,33.8307 46.3886,38.2723
                53.0702,4.6228 -0.2829,18.3891 13.7366,22.1167
                21.2446,8.4157 2.5022,-4.5667 2.8474,-8.8107
                3.9074,-13.7016 6.5131,-30.0453 41.1244,-25.5072
                40.2493,5.4702 l 0.009,16.4111 -0.009,-16.4111 C
                147.4692,16.0364 202.508,17.7243 200.26,51.4333
                l 0.2813,16.4715 -0.2813,-16.4715 c 1.501,-33.2526
                49.5022,-32.5328 54.7478,-3.8861 0.9657,5.2737
                1.5125,12.2994 1.6598,19.8872 0.2813,14.4863
                0.2448,30.639 -1.1508,41.1661 -5.8564,44.1732
                -76.9434,50.8064 -79.6948,0.0788 1.2135,53.8592
                -57.7041,51.9733 -64.1966,17.6293 -0.9645,-5.1027
                -1.4745,-11.006 -1.0196,-17.6815 C 94.6341,180.8337
                0.3668,136.7911 25.581,53.5973 l 1.7133,-6.7868"
              inkscape:connector-curvature="0"
              style="stroke-linecap:round;stroke-linejoin:round"
            />
            <rect
              id="punto2"
              class="str1 fil1"
              x="173.255"
              y="94.910301"
              width="4.9043598"
              height="4.9675398"
              rx="0.6002"
              ry="0.6002"
              style="fill:#ffffff;stroke:#ffffff;stroke-width:6.64440012"
            />
            <rect
              id="punto1"
              class="str1 fil1"
              x="109.55"
              y="94.499298"
              width="4.9043598"
              height="4.9675398"
              rx="0.6002"
              ry="0.6002"
              style="fill:#ffffff;stroke:#ffffff;stroke-width:6.64440012"
            />
            <path
              id="esteto"
              class="fil0 str1"
              d="m 142.348,151.551 -0.0997,36.9673 c 0.0327,15.2
                18.7399,18.5665 29.262,6.2739 l 7.0332,-7.5885"
              inkscape:connector-curvature="0"
              sodipodi:nodetypes="cccc"
            />
            <circle
              id="scopio"
              style="stroke-linecap:butt;stroke-linejoin:round;"
              class="str1 fil0"
              cx="-0.74246454"
              cy="-257.70447"
              r="9.7580128"
              transform="rotate(135)"
            />
          </g>
        </svg>
        <!-- eslint-enable -->
      </div>
      <div
        class="col-12 col-sm-10 col-md-6 col-xl-5 order-md-1 pr-md-3 pl-md-4
          pl-lg-5"
      >
        <figure>
          <!-- eslint-disable -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="371"
            height="177"
            fill="none"
            viewBox="0 0 371 177"
          >
            <path id="vector-asistente" d="M20.6895 27.4902L9.95801 67H0.870117L15.6621 20.0781H21.334L20.6895 27.4902ZM29.165 67L18.4336 27.4902L17.6924 20.0781H23.4287L38.2852 67H29.165ZM29.4551 49.5332V56.7197H7.92773V49.5332H29.4551ZM58.4912 57.6865C58.4912 57.0205 58.2764 56.4297 57.8467 55.9141C57.4385 55.3984 56.7832 54.8721 55.8809 54.335C54.9785 53.7979 53.7861 53.2178 52.3037 52.5947C50.6924 51.9502 49.2637 51.2949 48.0176 50.6289C46.793 49.9414 45.751 49.1895 44.8916 48.373C44.0322 47.5352 43.3877 46.5898 42.958 45.5371C42.5283 44.4629 42.3135 43.2275 42.3135 41.8311C42.3135 40.3916 42.582 39.0488 43.1191 37.8027C43.6562 36.5566 44.4297 35.4609 45.4395 34.5156C46.4707 33.5703 47.7168 32.8291 49.1777 32.292C50.6387 31.7549 52.2822 31.4863 54.1084 31.4863C56.665 31.4863 58.8564 31.9482 60.6826 32.8721C62.5303 33.7744 63.9375 35.042 64.9043 36.6748C65.8926 38.3076 66.3867 40.1875 66.3867 42.3145H58.1367C58.1367 41.498 57.9971 40.7568 57.7178 40.0908C57.4385 39.4248 56.998 38.8984 56.3965 38.5117C55.7949 38.1035 55.0215 37.8994 54.0762 37.8994C53.2812 37.8994 52.5938 38.0605 52.0137 38.3828C51.4551 38.7051 51.0254 39.1348 50.7246 39.6719C50.4238 40.1875 50.2734 40.7783 50.2734 41.4443C50.2734 41.96 50.3701 42.4111 50.5635 42.7979C50.7783 43.1846 51.1113 43.5605 51.5625 43.9258C52.0137 44.2695 52.6152 44.6348 53.3672 45.0215C54.1406 45.3867 55.0967 45.8164 56.2354 46.3105C58.5557 47.1914 60.4785 48.126 62.0039 49.1143C63.5293 50.0811 64.668 51.2197 65.4199 52.5303C66.1719 53.8193 66.5479 55.4307 66.5479 57.3643C66.5479 58.8896 66.2578 60.2861 65.6777 61.5537C65.0977 62.8213 64.2598 63.917 63.1641 64.8408C62.0898 65.7432 60.79 66.4414 59.2646 66.9355C57.7393 67.4082 56.0312 67.6445 54.1406 67.6445C51.3691 67.6445 49.0273 67.0967 47.1152 66.001C45.2246 64.9053 43.7852 63.4873 42.7969 61.7471C41.8301 60.0068 41.3467 58.1914 41.3467 56.3008H49.2744C49.3174 57.5469 49.5645 58.5352 50.0156 59.2656C50.4883 59.9746 51.1006 60.4688 51.8525 60.748C52.6045 61.0273 53.4102 61.167 54.2695 61.167C55.2148 61.167 55.999 61.0381 56.6221 60.7803C57.2451 60.501 57.707 60.1035 58.0078 59.5879C58.3301 59.0508 58.4912 58.417 58.4912 57.6865ZM81.4365 32.1309V67H73.1543V32.1309H81.4365ZM72.7354 23.0752C72.7354 21.7646 73.1436 20.6797 73.96 19.8203C74.7764 18.9609 75.8936 18.5312 77.3115 18.5312C78.7295 18.5312 79.8359 18.9609 80.6309 19.8203C81.4258 20.6582 81.8232 21.7324 81.8232 23.043C81.8232 24.332 81.4258 25.4062 80.6309 26.2656C79.8359 27.1035 78.7295 27.5225 77.3115 27.5225C75.8936 27.5225 74.7764 27.1035 73.96 26.2656C73.1436 25.4062 72.7354 24.3428 72.7354 23.0752ZM104.833 57.6865C104.833 57.0205 104.618 56.4297 104.188 55.9141C103.78 55.3984 103.125 54.8721 102.223 54.335C101.32 53.7979 100.128 53.2178 98.6455 52.5947C97.0342 51.9502 95.6055 51.2949 94.3594 50.6289C93.1348 49.9414 92.0928 49.1895 91.2334 48.373C90.374 47.5352 89.7295 46.5898 89.2998 45.5371C88.8701 44.4629 88.6553 43.2275 88.6553 41.8311C88.6553 40.3916 88.9238 39.0488 89.4609 37.8027C89.998 36.5566 90.7715 35.4609 91.7812 34.5156C92.8125 33.5703 94.0586 32.8291 95.5195 32.292C96.9805 31.7549 98.624 31.4863 100.45 31.4863C103.007 31.4863 105.198 31.9482 107.024 32.8721C108.872 33.7744 110.279 35.042 111.246 36.6748C112.234 38.3076 112.729 40.1875 112.729 42.3145H104.479C104.479 41.498 104.339 40.7568 104.06 40.0908C103.78 39.4248 103.34 38.8984 102.738 38.5117C102.137 38.1035 101.363 37.8994 100.418 37.8994C99.623 37.8994 98.9355 38.0605 98.3555 38.3828C97.7969 38.7051 97.3672 39.1348 97.0664 39.6719C96.7656 40.1875 96.6152 40.7783 96.6152 41.4443C96.6152 41.96 96.7119 42.4111 96.9053 42.7979C97.1201 43.1846 97.4531 43.5605 97.9043 43.9258C98.3555 44.2695 98.957 44.6348 99.709 45.0215C100.482 45.3867 101.438 45.8164 102.577 46.3105C104.897 47.1914 106.82 48.126 108.346 49.1143C109.871 50.0811 111.01 51.2197 111.762 52.5303C112.514 53.8193 112.89 55.4307 112.89 57.3643C112.89 58.8896 112.6 60.2861 112.02 61.5537C111.439 62.8213 110.602 63.917 109.506 64.8408C108.432 65.7432 107.132 66.4414 105.606 66.9355C104.081 67.4082 102.373 67.6445 100.482 67.6445C97.7109 67.6445 95.3691 67.0967 93.457 66.001C91.5664 64.9053 90.127 63.4873 89.1387 61.7471C88.1719 60.0068 87.6885 58.1914 87.6885 56.3008H95.6162C95.6592 57.5469 95.9062 58.5352 96.3574 59.2656C96.8301 59.9746 97.4424 60.4688 98.1943 60.748C98.9463 61.0273 99.752 61.167 100.611 61.167C101.557 61.167 102.341 61.0381 102.964 60.7803C103.587 60.501 104.049 60.1035 104.35 59.5879C104.672 59.0508 104.833 58.417 104.833 57.6865ZM133.708 32.1309V38.415H116.273V32.1309H133.708ZM120.656 23.5586H128.874V56.8164C128.874 57.8477 128.981 58.6318 129.196 59.1689C129.411 59.7061 129.723 60.0713 130.131 60.2646C130.561 60.458 131.076 60.5547 131.678 60.5547C132.129 60.5547 132.559 60.5225 132.967 60.458C133.375 60.3936 133.676 60.3291 133.869 60.2646L133.837 66.8389C133.214 67.0752 132.526 67.2686 131.774 67.4189C131.022 67.5693 130.12 67.6445 129.067 67.6445C127.392 67.6445 125.92 67.3115 124.652 66.6455C123.406 65.9795 122.429 64.9053 121.72 63.4229C121.011 61.9404 120.656 59.9854 120.656 57.5576V23.5586ZM152.851 67.6445C150.53 67.6445 148.468 67.29 146.663 66.5811C144.88 65.8721 143.365 64.8408 142.119 63.4873C140.873 62.1338 139.917 60.4688 139.251 58.4922C138.606 56.5156 138.284 54.249 138.284 51.6924V48.5664C138.284 45.666 138.617 43.1523 139.283 41.0254C139.949 38.877 140.873 37.1045 142.055 35.708C143.258 34.29 144.697 33.2373 146.373 32.5498C148.07 31.8408 149.939 31.4863 151.98 31.4863C154.172 31.4863 156.084 31.8516 157.717 32.582C159.371 33.291 160.735 34.3545 161.81 35.7725C162.884 37.1904 163.679 38.9521 164.194 41.0576C164.731 43.1416 165 45.5586 165 48.3086V52.2725H141.99V46.2461H156.879V45.4404C156.836 43.9365 156.653 42.6582 156.331 41.6055C156.009 40.5527 155.493 39.7578 154.784 39.2207C154.097 38.6621 153.151 38.3828 151.948 38.3828C151.003 38.3828 150.187 38.5762 149.499 38.9629C148.812 39.3281 148.253 39.9082 147.823 40.7031C147.415 41.4766 147.104 42.5186 146.889 43.8291C146.674 45.1182 146.566 46.6973 146.566 48.5664V51.6924C146.566 53.3467 146.717 54.7539 147.018 55.9141C147.318 57.0527 147.759 57.9873 148.339 58.7178C148.919 59.4268 149.628 59.9424 150.466 60.2646C151.304 60.5869 152.281 60.748 153.398 60.748C155.074 60.748 156.546 60.4473 157.813 59.8457C159.081 59.2227 160.177 58.3955 161.101 57.3643L164.549 62.4238C163.926 63.2617 163.077 64.0889 162.003 64.9053C160.929 65.7002 159.629 66.3555 158.104 66.8711C156.6 67.3867 154.849 67.6445 152.851 67.6445ZM178.761 39.5752V67H170.479V32.1309H178.245L178.761 39.5752ZM177.407 48.3408L175.022 48.373C174.979 45.8164 175.227 43.5068 175.764 41.4443C176.322 39.3604 177.117 37.5771 178.148 36.0947C179.201 34.6123 180.447 33.4736 181.887 32.6787C183.326 31.8838 184.927 31.4863 186.688 31.4863C188.063 31.4863 189.31 31.7227 190.427 32.1953C191.565 32.668 192.543 33.4199 193.359 34.4512C194.176 35.4824 194.81 36.8359 195.261 38.5117C195.712 40.1875 195.938 42.2393 195.938 44.667V67H187.655V44.6025C187.655 43.0342 187.483 41.8096 187.14 40.9287C186.817 40.0264 186.334 39.3926 185.689 39.0273C185.066 38.6406 184.261 38.4473 183.272 38.4473C182.349 38.4473 181.521 38.7051 180.791 39.2207C180.061 39.7363 179.438 40.4453 178.922 41.3477C178.428 42.25 178.052 43.3027 177.794 44.5059C177.536 45.6875 177.407 46.9658 177.407 48.3408ZM217.626 32.1309V38.415H200.191V32.1309H217.626ZM204.574 23.5586H212.792V56.8164C212.792 57.8477 212.899 58.6318 213.114 59.1689C213.329 59.7061 213.641 60.0713 214.049 60.2646C214.479 60.458 214.994 60.5547 215.596 60.5547C216.047 60.5547 216.477 60.5225 216.885 60.458C217.293 60.3936 217.594 60.3291 217.787 60.2646L217.755 66.8389C217.132 67.0752 216.444 67.2686 215.692 67.4189C214.94 67.5693 214.038 67.6445 212.985 67.6445C211.31 67.6445 209.838 67.3115 208.57 66.6455C207.324 65.9795 206.347 64.9053 205.638 63.4229C204.929 61.9404 204.574 59.9854 204.574 57.5576V23.5586ZM236.769 67.6445C234.448 67.6445 232.386 67.29 230.581 66.5811C228.798 65.8721 227.283 64.8408 226.037 63.4873C224.791 62.1338 223.835 60.4688 223.169 58.4922C222.524 56.5156 222.202 54.249 222.202 51.6924V48.5664C222.202 45.666 222.535 43.1523 223.201 41.0254C223.867 38.877 224.791 37.1045 225.973 35.708C227.176 34.29 228.615 33.2373 230.291 32.5498C231.988 31.8408 233.857 31.4863 235.898 31.4863C238.09 31.4863 240.002 31.8516 241.635 32.582C243.289 33.291 244.653 34.3545 245.728 35.7725C246.802 37.1904 247.597 38.9521 248.112 41.0576C248.649 43.1416 248.918 45.5586 248.918 48.3086V52.2725H225.908V46.2461H240.797V45.4404C240.754 43.9365 240.571 42.6582 240.249 41.6055C239.927 40.5527 239.411 39.7578 238.702 39.2207C238.015 38.6621 237.069 38.3828 235.866 38.3828C234.921 38.3828 234.104 38.5762 233.417 38.9629C232.729 39.3281 232.171 39.9082 231.741 40.7031C231.333 41.4766 231.021 42.5186 230.807 43.8291C230.592 45.1182 230.484 46.6973 230.484 48.5664V51.6924C230.484 53.3467 230.635 54.7539 230.936 55.9141C231.236 57.0527 231.677 57.9873 232.257 58.7178C232.837 59.4268 233.546 59.9424 234.384 60.2646C235.222 60.5869 236.199 60.748 237.316 60.748C238.992 60.748 240.464 60.4473 241.731 59.8457C242.999 59.2227 244.095 58.3955 245.019 57.3643L248.467 62.4238C247.844 63.2617 246.995 64.0889 245.921 64.9053C244.847 65.7002 243.547 66.3555 242.021 66.8711C240.518 67.3867 238.767 67.6445 236.769 67.6445Z" fill="white"/>
            <path id="vector-medico" d="M9.10547 97.2812H19.6465L31.8281 138.133L43.9688 97.2812H53.2793L36.2988 157H27.3164L9.10547 97.2812ZM4.83984 97.2812H14.8887L16.4473 136.656V157H4.83984V97.2812ZM48.6855 97.2812H58.7754V157H47.209V136.656L48.6855 97.2812ZM85.8867 157.82C82.8516 157.82 80.1582 157.355 77.8066 156.426C75.4824 155.496 73.5137 154.156 71.9004 152.406C70.2871 150.629 69.0566 148.482 68.209 145.967C67.3613 143.451 66.9375 140.58 66.9375 137.354V133.703C66.9375 130.094 67.3477 126.936 68.168 124.229C68.9883 121.494 70.1504 119.197 71.6543 117.338C73.1582 115.479 75.0039 114.098 77.1914 113.195C79.4062 112.266 81.9082 111.801 84.6973 111.801C87.4863 111.801 89.9336 112.266 92.0391 113.195C94.1719 114.098 95.9355 115.465 97.3301 117.297C98.7246 119.102 99.7773 121.344 100.488 124.023C101.199 126.703 101.555 129.82 101.555 133.375V138.625H71.8184V130.545H90.2754V129.52C90.2754 127.715 90.084 126.211 89.7012 125.008C89.3184 123.777 88.7168 122.861 87.8965 122.26C87.0762 121.658 85.9824 121.357 84.6152 121.357C83.4668 121.357 82.4961 121.59 81.7031 122.055C80.9102 122.52 80.2812 123.244 79.8164 124.229C79.3516 125.213 79.0098 126.498 78.791 128.084C78.5723 129.643 78.4629 131.516 78.4629 133.703V137.354C78.4629 139.404 78.6406 141.127 78.9961 142.521C79.3516 143.889 79.8711 145.01 80.5547 145.885C81.2656 146.732 82.127 147.348 83.1387 147.73C84.1504 148.086 85.3262 148.264 86.666 148.264C88.6895 148.264 90.5078 147.908 92.1211 147.197C93.7617 146.459 95.1562 145.461 96.3047 144.203L100.898 151.176C100.105 152.215 99.0117 153.254 97.6172 154.293C96.2227 155.332 94.5547 156.18 92.6133 156.836C90.6719 157.492 88.4297 157.82 85.8867 157.82ZM77.5605 106.633L85.5996 93.959H98.5195L87.1992 106.633H77.5605ZM129.691 147.197V94H141.217V157L130.799 157.041L129.691 147.197ZM106.682 136.369V133.416C106.682 129.807 106.982 126.648 107.584 123.941C108.213 121.234 109.143 118.979 110.373 117.174C111.604 115.369 113.107 114.029 114.885 113.154C116.689 112.252 118.754 111.801 121.078 111.801C123.184 111.801 125.029 112.334 126.615 113.4C128.229 114.439 129.596 115.902 130.717 117.789C131.838 119.676 132.74 121.904 133.424 124.475C134.107 127.045 134.586 129.861 134.859 132.924V137.189C134.531 140.088 134.025 142.795 133.342 145.311C132.686 147.826 131.783 150.014 130.635 151.873C129.514 153.732 128.16 155.195 126.574 156.262C124.988 157.301 123.143 157.82 121.037 157.82C118.713 157.82 116.648 157.355 114.844 156.426C113.066 155.496 111.562 154.129 110.332 152.324C109.129 150.492 108.213 148.25 107.584 145.598C106.982 142.918 106.682 139.842 106.682 136.369ZM118.166 133.416V136.369C118.166 138.447 118.262 140.238 118.453 141.742C118.672 143.219 119.014 144.436 119.479 145.393C119.971 146.322 120.613 147.02 121.406 147.484C122.199 147.922 123.184 148.141 124.359 148.141C125.891 148.141 127.135 147.758 128.092 146.992C129.049 146.199 129.76 145.119 130.225 143.752C130.717 142.357 130.99 140.758 131.045 138.953V131.201C130.99 129.697 130.812 128.344 130.512 127.141C130.211 125.938 129.787 124.912 129.24 124.064C128.693 123.217 128.01 122.561 127.189 122.096C126.396 121.631 125.467 121.398 124.4 121.398C123.252 121.398 122.268 121.631 121.447 122.096C120.654 122.561 120.025 123.285 119.561 124.27C119.096 125.227 118.74 126.471 118.494 128.002C118.275 129.506 118.166 131.311 118.166 133.416ZM161.93 112.621V157H150.404V112.621H161.93ZM149.871 101.137C149.871 99.3594 150.432 97.8965 151.553 96.748C152.701 95.5723 154.246 94.9844 156.188 94.9844C158.102 94.9844 159.619 95.5586 160.74 96.707C161.861 97.8555 162.422 99.3184 162.422 101.096C162.422 102.873 161.861 104.35 160.74 105.525C159.619 106.674 158.102 107.248 156.188 107.248C154.246 107.248 152.701 106.674 151.553 105.525C150.432 104.35 149.871 102.887 149.871 101.137ZM187.072 148.264C188.139 148.264 189.055 148.045 189.82 147.607C190.613 147.17 191.215 146.459 191.625 145.475C192.035 144.49 192.254 143.219 192.281 141.66H203.068C203.068 144.996 202.357 147.881 200.936 150.314C199.541 152.721 197.654 154.58 195.275 155.893C192.924 157.178 190.258 157.82 187.277 157.82C184.297 157.82 181.699 157.342 179.484 156.385C177.27 155.428 175.438 154.033 173.988 152.201C172.566 150.369 171.486 148.141 170.748 145.516C170.037 142.863 169.682 139.828 169.682 136.41V133.17C169.682 129.807 170.037 126.799 170.748 124.146C171.486 121.494 172.566 119.252 173.988 117.42C175.438 115.588 177.256 114.193 179.443 113.236C181.658 112.279 184.256 111.801 187.236 111.801C190.436 111.801 193.211 112.471 195.562 113.811C197.914 115.123 199.746 117.064 201.059 119.635C202.398 122.205 203.068 125.377 203.068 129.15H192.281C192.254 127.455 192.049 126.047 191.666 124.926C191.311 123.777 190.75 122.902 189.984 122.301C189.246 121.672 188.262 121.357 187.031 121.357C185.746 121.357 184.707 121.631 183.914 122.178C183.148 122.697 182.561 123.463 182.15 124.475C181.768 125.459 181.508 126.689 181.371 128.166C181.234 129.643 181.166 131.311 181.166 133.17V136.41C181.166 138.406 181.221 140.143 181.33 141.619C181.467 143.068 181.727 144.299 182.109 145.311C182.52 146.295 183.107 147.033 183.873 147.525C184.666 148.018 185.732 148.264 187.072 148.264ZM208.359 136.328V133.334C208.359 129.861 208.77 126.785 209.59 124.105C210.438 121.426 211.641 119.184 213.199 117.379C214.758 115.547 216.631 114.166 218.818 113.236C221.033 112.279 223.508 111.801 226.242 111.801C229.004 111.801 231.479 112.279 233.666 113.236C235.881 114.166 237.768 115.547 239.326 117.379C240.912 119.184 242.129 121.426 242.977 124.105C243.824 126.785 244.248 129.861 244.248 133.334V136.328C244.248 139.773 243.824 142.836 242.977 145.516C242.129 148.195 240.912 150.451 239.326 152.283C237.768 154.115 235.895 155.496 233.707 156.426C231.52 157.355 229.059 157.82 226.324 157.82C223.59 157.82 221.115 157.355 218.9 156.426C216.713 155.496 214.826 154.115 213.24 152.283C211.654 150.451 210.438 148.195 209.59 145.516C208.77 142.836 208.359 139.773 208.359 136.328ZM219.844 133.334V136.328C219.844 138.379 219.98 140.156 220.254 141.66C220.555 143.164 220.979 144.408 221.525 145.393C222.1 146.377 222.783 147.102 223.576 147.566C224.369 148.031 225.285 148.264 226.324 148.264C227.363 148.264 228.293 148.031 229.113 147.566C229.934 147.102 230.604 146.377 231.123 145.393C231.67 144.408 232.066 143.164 232.312 141.66C232.586 140.156 232.723 138.379 232.723 136.328V133.334C232.723 131.338 232.572 129.588 232.271 128.084C231.971 126.553 231.547 125.309 231 124.352C230.453 123.367 229.77 122.629 228.949 122.137C228.156 121.617 227.254 121.357 226.242 121.357C225.23 121.357 224.328 121.617 223.535 122.137C222.77 122.629 222.1 123.367 221.525 124.352C220.979 125.309 220.555 126.553 220.254 128.084C219.98 129.588 219.844 131.338 219.844 133.334Z" fill="white"/>
            <path id="vector-integral" d="M273.031 169.18H310V172.1H273.031V169.18ZM288.393 154.843H310V157.661H282.527V154.995L288.393 154.843ZM294.562 155.478L293.826 156.722C292.201 156.671 290.678 156.409 289.256 155.935C287.817 155.461 286.556 154.826 285.473 154.031C284.389 153.218 283.543 152.262 282.934 151.161C282.324 150.061 282.02 148.834 282.02 147.48C282.02 146.346 282.206 145.322 282.578 144.408C282.951 143.494 283.543 142.723 284.355 142.097C285.151 141.471 286.192 140.988 287.479 140.65C288.748 140.311 290.288 140.142 292.1 140.142H310V142.935H292.074C290.195 142.935 288.723 143.147 287.656 143.57C286.573 143.993 285.811 144.602 285.371 145.398C284.931 146.176 284.711 147.116 284.711 148.216C284.711 149.384 285.024 150.417 285.65 151.314C286.277 152.211 287.089 152.964 288.088 153.574C289.087 154.183 290.161 154.648 291.312 154.97C292.447 155.292 293.53 155.461 294.562 155.478ZM282.527 120.803H285.066V132.534H282.527V120.803ZM275.494 128.319V125.475H303.297C304.566 125.475 305.523 125.34 306.166 125.069C306.809 124.798 307.241 124.443 307.461 124.003C307.664 123.563 307.766 123.097 307.766 122.606C307.766 122.217 307.74 121.853 307.689 121.514C307.639 121.159 307.579 120.837 307.512 120.55L310.102 120.473C310.22 120.778 310.313 121.184 310.381 121.692C310.465 122.2 310.508 122.716 310.508 123.241C310.508 124.206 310.288 125.069 309.848 125.831C309.408 126.592 308.663 127.202 307.613 127.659C306.547 128.099 305.1 128.319 303.271 128.319H275.494ZM310.533 102.734C310.533 104.258 310.288 105.654 309.797 106.924C309.289 108.193 308.527 109.294 307.512 110.225C306.479 111.139 305.184 111.85 303.627 112.358C302.053 112.865 300.199 113.119 298.066 113.119H294.893C292.624 113.119 290.678 112.857 289.053 112.332C287.411 111.79 286.074 111.054 285.041 110.123C284.008 109.192 283.247 108.134 282.756 106.949C282.265 105.764 282.02 104.52 282.02 103.217C282.02 101.71 282.265 100.382 282.756 99.2305C283.247 98.0795 283.992 97.1231 284.99 96.3614C285.972 95.5828 287.225 94.9988 288.748 94.6095C290.271 94.2032 292.066 94.0001 294.131 94.0001H296.492V111.418H293.852V96.8184H293.141C291.346 96.8523 289.823 97.1062 288.57 97.5802C287.301 98.0372 286.336 98.7312 285.676 99.6622C284.999 100.593 284.66 101.77 284.66 103.191C284.66 104.241 284.855 105.206 285.244 106.086C285.617 106.949 286.209 107.703 287.021 108.346C287.834 108.972 288.892 109.455 290.195 109.793C291.499 110.132 293.064 110.301 294.893 110.301H298.066C299.759 110.301 301.223 110.123 302.459 109.768C303.678 109.395 304.693 108.871 305.506 108.193C306.301 107.499 306.902 106.678 307.309 105.731C307.698 104.783 307.893 103.733 307.893 102.582C307.893 101.177 307.647 99.9415 307.156 98.8751C306.665 97.8087 305.929 96.8608 304.947 96.0313L306.826 94.5333C307.503 95.0242 308.121 95.642 308.68 96.3868C309.238 97.1316 309.687 98.0203 310.025 99.0528C310.364 100.085 310.533 101.313 310.533 102.734ZM282.527 69.9643V67.3745H310.686C313.072 67.3745 315.019 67.7468 316.525 68.4916C318.032 69.2364 319.141 70.2944 319.852 71.6655C320.579 73.0366 320.943 74.6616 320.943 76.5405C320.943 77.4376 320.791 78.4024 320.486 79.435C320.199 80.4506 319.767 81.4155 319.191 82.3295C318.633 83.2267 317.956 83.9884 317.16 84.6147L315.129 83.2944C316.195 82.3465 316.991 81.3224 317.516 80.2221C318.057 79.1218 318.328 77.9623 318.328 76.7436C318.328 75.3386 318.074 74.1453 317.566 73.1635C317.076 72.1817 316.28 71.437 315.18 70.9291C314.079 70.4213 312.615 70.1674 310.787 70.1674H288.57L282.527 69.9643ZM297.559 86.1127H294.994C292.692 86.1127 290.72 85.9096 289.078 85.5034C287.419 85.0971 286.074 84.5047 285.041 83.726C283.992 82.9304 283.23 81.9825 282.756 80.8823C282.265 79.782 282.02 78.5379 282.02 77.1498C282.02 75.8126 282.265 74.6446 282.756 73.6459C283.247 72.6303 283.949 71.767 284.863 71.0561C285.777 70.3452 286.869 69.7696 288.139 69.3295C289.408 68.8894 290.822 68.5678 292.379 68.3647H300.605C302.044 68.534 303.373 68.8386 304.592 69.2787C305.811 69.7019 306.86 70.2774 307.74 71.0053C308.62 71.7162 309.306 72.588 309.797 73.6205C310.288 74.6362 310.533 75.8295 310.533 77.2006C310.533 78.5717 310.271 79.8074 309.746 80.9077C309.221 82.0079 308.426 82.9474 307.359 83.726C306.293 84.5047 304.947 85.0971 303.322 85.5034C301.697 85.9096 299.776 86.1127 297.559 86.1127ZM294.994 83.269H297.559C299.336 83.269 300.868 83.142 302.154 82.8881C303.441 82.6173 304.507 82.211 305.354 81.6694C306.183 81.1277 306.801 80.4422 307.207 79.6127C307.613 78.7664 307.816 77.7677 307.816 76.6166C307.816 75.1948 307.52 74.0014 306.928 73.0366C306.318 72.0717 305.523 71.31 304.541 70.7514C303.542 70.1759 302.459 69.7442 301.291 69.4565H291.871C291.059 69.6258 290.238 69.8712 289.408 70.1928C288.579 70.5144 287.809 70.9545 287.098 71.5131C286.37 72.0548 285.794 72.7403 285.371 73.5698C284.931 74.3992 284.711 75.4064 284.711 76.5912C284.711 77.7423 284.923 78.741 285.346 79.5873C285.752 80.4337 286.378 81.1277 287.225 81.6694C288.054 82.211 289.112 82.6173 290.398 82.8881C291.685 83.142 293.217 83.269 294.994 83.269ZM287.072 54.1297H310V56.948H282.527V54.2059L287.072 54.1297ZM282.324 46.1316L285.168 46.2332C285.1 46.521 285.058 46.8003 285.041 47.0711C285.007 47.325 284.99 47.6212 284.99 47.9598C284.99 49.0262 285.227 49.9656 285.701 50.7781C286.175 51.5737 286.844 52.2508 287.707 52.8094C288.553 53.351 289.544 53.7742 290.678 54.0789C291.795 54.3667 293.005 54.5359 294.309 54.5867L294.74 55.5516C292.963 55.5516 291.304 55.3992 289.764 55.0945C288.223 54.7898 286.878 54.3243 285.727 53.698C284.559 53.0548 283.653 52.2508 283.01 51.2859C282.35 50.3211 282.02 49.17 282.02 47.8328C282.02 47.5281 282.053 47.215 282.121 46.8934C282.172 46.5548 282.24 46.3009 282.324 46.1316ZM305.074 25.3966H290.119C288.833 25.3966 287.792 25.6167 286.996 26.0568C286.184 26.4969 285.591 27.1401 285.219 27.9865C284.846 28.8328 284.66 29.8823 284.66 31.1349C284.66 32.3029 284.897 33.3354 285.371 34.2326C285.828 35.1297 286.471 35.8322 287.301 36.34C288.113 36.8478 289.053 37.1017 290.119 37.1017L290.094 39.9201C289.044 39.9201 288.029 39.7085 287.047 39.2853C286.065 38.8452 285.202 38.2358 284.457 37.4572C283.695 36.6785 283.103 35.7475 282.68 34.6642C282.24 33.564 282.02 32.3452 282.02 31.008C282.02 29.383 282.282 27.9357 282.807 26.6662C283.331 25.3966 284.195 24.4064 285.396 23.6955C286.598 22.9676 288.189 22.6037 290.17 22.6037H304.236C305.184 22.6037 306.166 22.5444 307.182 22.4259C308.197 22.2905 309.035 22.1043 309.695 21.8673H310V24.838C309.391 25.0242 308.629 25.1681 307.715 25.2697C306.801 25.3543 305.921 25.3966 305.074 25.3966ZM293.979 24.7873L296.365 24.7365V29.6115C296.365 30.9487 296.509 32.1167 296.797 33.1154C297.085 34.1141 297.499 34.952 298.041 35.6291C298.583 36.2892 299.234 36.7886 299.996 37.1271C300.741 37.4656 301.579 37.6349 302.51 37.6349C303.729 37.6349 304.727 37.4403 305.506 37.0509C306.285 36.6447 306.86 36.0692 307.232 35.3244C307.588 34.5796 307.766 33.674 307.766 32.6076C307.766 31.2365 307.486 30.0177 306.928 28.9513C306.369 27.8849 305.633 27.0132 304.719 26.3361C303.805 25.659 302.831 25.2189 301.799 25.0158L303.5 24.2541C304.279 24.4233 305.074 24.7365 305.887 25.1935C306.699 25.6505 307.461 26.243 308.172 26.9709C308.866 27.6987 309.433 28.562 309.873 29.5607C310.313 30.5594 310.533 31.6935 310.533 32.963C310.533 34.4526 310.245 35.7645 309.67 36.8986C309.094 38.0327 308.231 38.9129 307.08 39.5392C305.912 40.1486 304.473 40.4533 302.764 40.4533C301.494 40.4533 300.326 40.2332 299.26 39.7931C298.193 39.353 297.262 38.7013 296.467 37.838C295.671 36.9748 295.062 35.8914 294.639 34.588C294.199 33.2847 293.979 31.7697 293.979 30.0431V24.7873ZM271 8.90187H310V11.7202H271V8.90187Z" fill="white"/>
            <path id="vector-inteligente" d="M331.852 168.552H361V174.377H331.852V168.552ZM343.963 158.322H361V163.947H339.339V158.682L343.963 158.322ZM349.429 159.163L349.469 160.664C347.84 160.691 346.379 160.537 345.084 160.204C343.79 159.857 342.689 159.363 341.781 158.722C340.86 158.082 340.16 157.321 339.679 156.44C339.185 155.559 338.938 154.565 338.938 153.457C338.938 152.63 339.085 151.869 339.379 151.175C339.673 150.467 340.14 149.86 340.78 149.353C341.421 148.846 342.268 148.452 343.323 148.172C344.377 147.892 345.678 147.751 347.227 147.751H361V153.377H347.187C346.252 153.377 345.532 153.47 345.024 153.657C344.504 153.844 344.144 154.124 343.943 154.498C343.73 154.858 343.623 155.326 343.623 155.899C343.623 156.433 343.777 156.907 344.083 157.321C344.377 157.735 344.784 158.082 345.305 158.362C345.825 158.629 346.439 158.836 347.146 158.982C347.854 159.116 348.615 159.176 349.429 159.163ZM339.339 134.198H343.563V145.249H339.339V134.198ZM333.994 142.707V137.121H354.394C354.994 137.121 355.455 137.061 355.775 136.941C356.095 136.821 356.322 136.641 356.456 136.4C356.576 136.147 356.636 135.82 356.636 135.419C356.636 135.126 356.622 134.859 356.596 134.619C356.556 134.378 356.516 134.198 356.476 134.078H360.86C361.033 134.519 361.167 134.986 361.26 135.479C361.354 135.96 361.4 136.534 361.4 137.201C361.4 138.309 361.187 139.277 360.76 140.104C360.333 140.931 359.652 141.572 358.718 142.026C357.77 142.48 356.529 142.707 354.994 142.707H333.994ZM361.4 122.347C361.4 123.828 361.174 125.143 360.72 126.291C360.266 127.425 359.612 128.386 358.758 129.173C357.89 129.961 356.843 130.561 355.615 130.975C354.387 131.389 352.986 131.596 351.411 131.596H349.629C347.867 131.596 346.326 131.396 345.004 130.995C343.67 130.595 342.549 130.028 341.641 129.293C340.734 128.559 340.06 127.659 339.619 126.591C339.165 125.51 338.938 124.289 338.938 122.927C338.938 121.566 339.165 120.371 339.619 119.344C340.06 118.303 340.727 117.442 341.621 116.761C342.502 116.081 343.596 115.567 344.904 115.22C346.212 114.873 347.734 114.699 349.469 114.699H352.031V129.213H348.087V120.205H347.587C346.706 120.205 345.972 120.298 345.385 120.485C344.784 120.672 344.337 120.965 344.043 121.366C343.75 121.766 343.603 122.3 343.603 122.967C343.603 123.528 343.716 124.002 343.943 124.389C344.17 124.776 344.524 125.083 345.004 125.31C345.485 125.536 346.112 125.703 346.886 125.81C347.647 125.917 348.561 125.97 349.629 125.97H351.411C352.412 125.97 353.252 125.883 353.933 125.71C354.6 125.536 355.148 125.283 355.575 124.949C355.988 124.602 356.289 124.182 356.476 123.688C356.649 123.194 356.736 122.62 356.736 121.966C356.736 120.979 356.562 120.091 356.215 119.304C355.855 118.503 355.368 117.822 354.754 117.262L358.157 115.02C358.664 115.407 359.172 115.94 359.679 116.621C360.186 117.302 360.6 118.116 360.92 119.063C361.24 120.011 361.4 121.105 361.4 122.347ZM330.25 105.57H361V111.196H330.25V105.57ZM339.339 95.2402H361V100.866H339.339V95.2402ZM333.733 101.126C332.866 101.126 332.152 100.852 331.591 100.305C331.017 99.7446 330.73 98.9906 330.73 98.043C330.73 97.1087 331.011 96.368 331.571 95.8208C332.132 95.2736 332.846 95 333.713 95C334.581 95 335.302 95.2736 335.875 95.8208C336.436 96.368 336.716 97.1087 336.716 98.043C336.716 98.9906 336.436 99.7446 335.875 100.305C335.302 100.852 334.588 101.126 333.733 101.126ZM339.339 79.4048V74.3198H361C362.975 74.3198 364.59 74.7002 365.845 75.4609C367.113 76.2083 368.04 77.256 368.627 78.604C369.228 79.9386 369.528 81.5002 369.528 83.2886C369.528 83.9692 369.435 84.7367 369.248 85.5908C369.061 86.4316 368.774 87.2458 368.387 88.0332C368.014 88.8206 367.56 89.4679 367.026 89.9751L363.142 88.0732C363.663 87.5527 364.103 86.8721 364.463 86.0312C364.837 85.1904 365.024 84.363 365.024 83.5488C365.024 82.7614 364.897 82.1074 364.644 81.5869C364.403 81.0531 363.99 80.6527 363.402 80.3857C362.815 80.1055 362.028 79.9653 361.04 79.9653H344.364L339.339 79.4048ZM350.93 91.4966H349.489C347.727 91.4966 346.186 91.3298 344.864 90.9961C343.543 90.6624 342.442 90.182 341.561 89.5547C340.68 88.9274 340.026 88.16 339.599 87.2524C339.159 86.3315 338.938 85.3039 338.938 84.1694C338.938 82.9816 339.199 81.9873 339.719 81.1865C340.226 80.3857 340.94 79.7384 341.861 79.2446C342.782 78.7375 343.87 78.3504 345.125 78.0835C346.379 77.8032 347.754 77.5897 349.249 77.4429H351.331C352.745 77.5897 354.067 77.8299 355.294 78.1636C356.522 78.4839 357.59 78.911 358.498 79.4448C359.405 79.9787 360.119 80.6326 360.64 81.4067C361.147 82.1808 361.4 83.1151 361.4 84.2095C361.4 85.3306 361.174 86.3449 360.72 87.2524C360.266 88.1466 359.599 88.9141 358.718 89.5547C357.824 90.182 356.729 90.6624 355.435 90.9961C354.127 91.3298 352.625 91.4966 350.93 91.4966ZM349.489 85.8711H350.93C351.944 85.8711 352.819 85.811 353.553 85.6909C354.273 85.5575 354.867 85.3573 355.334 85.0903C355.788 84.8234 356.129 84.4831 356.355 84.0693C356.569 83.6423 356.676 83.1418 356.676 82.5679C356.676 81.7537 356.489 81.1064 356.115 80.626C355.728 80.1322 355.201 79.7718 354.534 79.5449C353.853 79.3047 353.072 79.1712 352.191 79.1445H348.408C347.674 79.1579 347.013 79.2446 346.426 79.4048C345.839 79.5516 345.338 79.7585 344.924 80.0254C344.511 80.2923 344.19 80.6393 343.963 81.0664C343.736 81.4801 343.623 81.9673 343.623 82.5278C343.623 83.1017 343.736 83.5955 343.963 84.0093C344.19 84.423 344.544 84.77 345.024 85.0503C345.492 85.3172 346.099 85.5241 346.846 85.6709C347.58 85.8044 348.461 85.8711 349.489 85.8711ZM361.4 61.4072C361.4 62.8887 361.174 64.2033 360.72 65.3511C360.266 66.4855 359.612 67.4465 358.758 68.2339C357.89 69.0213 356.843 69.6219 355.615 70.0356C354.387 70.4494 352.986 70.6562 351.411 70.6562H349.629C347.867 70.6562 346.326 70.4561 345.004 70.0557C343.67 69.6553 342.549 69.0881 341.641 68.354C340.734 67.62 340.06 66.7191 339.619 65.6514C339.165 64.5703 338.938 63.3491 338.938 61.9878C338.938 60.6265 339.165 59.432 339.619 58.4043C340.06 57.3633 340.727 56.5024 341.621 55.8218C342.502 55.1411 343.596 54.6273 344.904 54.2803C346.212 53.9333 347.734 53.7598 349.469 53.7598H352.031V68.2739H348.087V59.2651H347.587C346.706 59.2651 345.972 59.3586 345.385 59.5454C344.784 59.7323 344.337 60.0259 344.043 60.4263C343.75 60.8267 343.603 61.3605 343.603 62.0278C343.603 62.5884 343.716 63.0622 343.943 63.4492C344.17 63.8363 344.524 64.1432 345.004 64.3701C345.485 64.597 346.112 64.7638 346.886 64.8706C347.647 64.9774 348.561 65.0308 349.629 65.0308H351.411C352.412 65.0308 353.252 64.944 353.933 64.7705C354.6 64.597 355.148 64.3434 355.575 64.0098C355.988 63.6628 356.289 63.2424 356.476 62.7485C356.649 62.2547 356.736 61.6808 356.736 61.0269C356.736 60.0392 356.562 59.1517 356.215 58.3643C355.855 57.5635 355.368 56.8828 354.754 56.3223L358.157 54.0801C358.664 54.4671 359.172 55.001 359.679 55.6816C360.186 56.3623 360.6 57.1764 360.92 58.124C361.24 59.0716 361.4 60.166 361.4 61.4072ZM343.963 45.0112H361V50.6367H339.339V45.3716L343.963 45.0112ZM349.429 45.8521L349.469 47.3535C347.84 47.3802 346.379 47.2267 345.084 46.8931C343.79 46.5461 342.689 46.0522 341.781 45.4116C340.86 44.771 340.16 44.0103 339.679 43.1294C339.185 42.2485 338.938 41.2542 338.938 40.1465C338.938 39.319 339.085 38.5583 339.379 37.8643C339.673 37.1569 340.14 36.5496 340.78 36.0425C341.421 35.5353 342.268 35.1416 343.323 34.8613C344.377 34.5811 345.678 34.4409 347.227 34.4409H361V40.0664H347.187C346.252 40.0664 345.532 40.1598 345.024 40.3467C344.504 40.5335 344.144 40.8138 343.943 41.1875C343.73 41.5479 343.623 42.015 343.623 42.5889C343.623 43.1227 343.777 43.5965 344.083 44.0103C344.377 44.424 344.784 44.771 345.305 45.0513C345.825 45.3182 346.439 45.5251 347.146 45.6719C347.854 45.8053 348.615 45.8654 349.429 45.8521ZM339.339 20.8877H343.563V31.9385H339.339V20.8877ZM333.994 29.396V23.8105H354.394C354.994 23.8105 355.455 23.7505 355.775 23.6304C356.095 23.5103 356.322 23.3301 356.456 23.0898C356.576 22.8363 356.636 22.5093 356.636 22.1089C356.636 21.8153 356.622 21.5483 356.596 21.3081C356.556 21.0679 356.516 20.8877 356.476 20.7676H360.86C361.033 21.208 361.167 21.6751 361.26 22.1689C361.354 22.6494 361.4 23.2233 361.4 23.8906C361.4 24.9984 361.187 25.966 360.76 26.7935C360.333 27.6209 359.652 28.2616 358.718 28.7153C357.77 29.1691 356.529 29.396 354.994 29.396H333.994ZM361.4 9.03613C361.4 10.5176 361.174 11.8322 360.72 12.98C360.266 14.1144 359.612 15.0754 358.758 15.8628C357.89 16.6502 356.843 17.2508 355.615 17.6646C354.387 18.0783 352.986 18.2852 351.411 18.2852H349.629C347.867 18.2852 346.326 18.085 345.004 17.6846C343.67 17.2842 342.549 16.717 341.641 15.9829C340.734 15.2489 340.06 14.348 339.619 13.2803C339.165 12.1992 338.938 10.978 338.938 9.6167C338.938 8.25537 339.165 7.06087 339.619 6.0332C340.06 4.99219 340.727 4.13135 341.621 3.45068C342.502 2.77002 343.596 2.25618 344.904 1.90918C346.212 1.56217 347.734 1.38867 349.469 1.38867H352.031V15.9028H348.087V6.89404H347.587C346.706 6.89404 345.972 6.98747 345.385 7.17432C344.784 7.36117 344.337 7.65479 344.043 8.05518C343.75 8.45557 343.603 8.98942 343.603 9.65674C343.603 10.2173 343.716 10.6911 343.943 11.0781C344.17 11.4652 344.524 11.7721 345.004 11.999C345.485 12.2259 346.112 12.3927 346.886 12.4995C347.647 12.6063 348.561 12.6597 349.629 12.6597H351.411C352.412 12.6597 353.252 12.5729 353.933 12.3994C354.6 12.2259 355.148 11.9723 355.575 11.6387C355.988 11.2917 356.289 10.8713 356.476 10.3774C356.649 9.88363 356.736 9.30973 356.736 8.65576C356.736 7.66813 356.562 6.7806 356.215 5.99316C355.855 5.19238 355.368 4.51172 354.754 3.95117L358.157 1.70898C358.664 2.09603 359.172 2.62988 359.679 3.31055C360.186 3.99121 360.6 4.80534 360.92 5.75293C361.24 6.70052 361.4 7.79492 361.4 9.03613Z" fill="white"/>
          </svg>
          <!-- eslint-enable -->
        </figure>
        <p class="descripcion">
          <span class="font-weight-bold">AMII</span>
          es una aplicación médica en la nube
          <span class="font-italic">&laquo;online&raquo;</span>, cuya misión es
          mejorar y facilitar las relaciones entre pacientes, médicos y las
          instituciones relacionadas con la salud.
        </p>
      </div>
    </div>
    <!-- Finalidad -->
    <div class="finalidad">
      <header class="h2-responsive text-center mb-4">
        Creada con la finalidad
      </header>
      <ul>
        <li class="descripcion">
          <font-awesome-icon
            icon="user-md"
            size="3x"
            class="icon mt-1"
          />
          <p>
            <span class="d-block font-weight-bold">Agilizar el proceso</span>
            relacionado con visitar a tu médico de confianza
          </p>
        </li>
        <li class="descripcion">
          <font-awesome-icon
            icon="handshake"
            size="3x"
            class="icon mt-1"
          />
          <p>
            <span class="d-block font-weight-bold">Ser un espacio</span>
            donde paciente y médico puedan revisar el historial de sus
            encuentros
          </p>
        </li>
        <li class="descripcion">
          <font-awesome-icon
            icon="diagnoses"
            size="3x"
            class="icon mt-1"
          />
          <p>
            <span class="d-block font-weight-bold">Lograr un tratamiento</span>
            más personalizado en futuras atenciones
          </p>
        </li>
      </ul>
    </div>
    <!-- Desarrollada por -->
    <div class="container mt-n5 desarrollado">
      <header class="h2-responsive mb-2 mb-lg-4">
        Desarrollada por
      </header>
      <div class="columnas">
        <figure
          v-mdb-animate-on-scroll="{
            animation: 'pulse', position: -100
          }"
          class="imagen"
        >
          <img
            v-lazy="'/img/vectores/Membrete-CAISerT.svg'"
            alt="Membrete de CAISerT"
            class="membrete-caisert"
          >
        </figure>
        <div
          v-mdb-animate-on-scroll="{
            animation: 'fadeInRight', position: -100
          }"
          class="contenido"
        >
          <p>
            Nuestro objetivo principal es
            <span class="font-weight-bold">
              mejorar la relación médico - paciente</span>,
            y poner en manos de sus usuarios la información relevante que
            necesitan al momento, almacenada de forma privada y segura.
          </p>
          <p>
            Nuestro equipo está conformado por médicos de distintas
            especialidades e ingenieros de software de alto nivel, para
            entregar una experiencia de usuario agradable con los mejores
            estándares del área de la salud.
          </p>
          <p>
            Estamos en escucha constante de nuestros usuarios para mejorar cada
            día.
            <span class="font-italic">
              ¿Falta algo en AMII?
            </span>
            Escríbenos y lo haremos realidad.
          </p>
        </div>
        <figure
          v-mdb-animate-on-scroll="{
            animation: 'fadeInLeft', position: -25
          }"
          class="imagen"
        >
          <img
            v-lazy="'/img/vectores/Coding-workshop-pana.svg'"
            alt="Membrete de CAISerT"
            class="teamwork"
          >
        </figure>
      </div>
    </div>
    <!-- Nuestro reto -->
    <div class="green-waves">
      <div
        v-mdb-animate-on-scroll="{
          animation: 'zoomIn', position: -5
        }"
        class="col-12 col-md-5 col-lg-6 col-xl-auto px-md-0 pl-lg-2 pr-lg-5"
      >
        <span class="subtitle">Nuestro reto de ser</span>
        <header>
          ¡Tu mejor Asistente Médico!
          <img
            v-lazy="'/img/vectores/medalla.svg'"
            alt="Medalla de oro para AMII"
            height="25"
            width="25"
          >
        </header>
        <p>
          Comenzó en 2019, trabajando en conjunto con profesionales de la salud
          e ingenieros especializados en software, con el objetivo de brindarte
          una aplicación de calidad, cuyo uso agregue valor a tu vida.
        </p>
      </div>
      <figure
        v-mdb-animate-on-scroll="{
          animation: 'flipInX', position: -5
        }"
        class="col-10 col-sm-6 col-md-5 col-lg-4 col-xl-auto px-0"
      >
        <img
          v-lazy="'/img/vectores/Online-review-pana.svg'"
          alt="Vector comentarios"
          height="auto"
          width="100%"
        >
      </figure>
    </div>
    <!-- Beneficios -->
    <section class="our-services container mt-4">
      <header class="col-12 mb-2 h2-responsive text-center">
        Principales beneficios
      </header>
      <div
        v-mdb-animate-on-scroll="{
          animation: 'fadeInLeft', position: -25
        }"
        class="col-10 col-md-6 col-lg-5 col-xl-4"
      >
        <img
          v-lazy="'/img/soy-medico/doctores.svg'"
          alt="Vectores de doctores"
        >
        <header>Médicos</header>
        <p class="text-muted font-italic">
          Gestiona las citas e historias de los pacientes de forma rápida,
          sin tener que escribir lo frecuente, desde el celular o computadora.
        </p>
      </div>
      <div
        v-mdb-animate-on-scroll="{
          animation: 'fadeInRight', position: -25
        }"
        class="col-10 col-md-6 col-lg-5 col-xl-4"
      >
        <img
          v-lazy="'/img/soy-medico/pacientes.svg'"
          alt="Vectores de pacientes"
        >
        <header>Pacientes</header>
        <p class="text-muted font-italic">
          Busca especialistas y reserva citas. Visualiza tus récipes, sus
          indicaciones y tratamientos; así como los de tus hijos.
        </p>
      </div>
    </section>
    <Footer />
  </section>
</template>
<script>
import Footer from '@/components/layout/Footer.vue';
import {mdbAnimateOnScroll} from 'mdbvue';

export default {
  name: 'Nosotros',
  components: {
    Footer,
  },
  directives: {
    mdbAnimateOnScroll,
  },
  data() {
    return {
    };
  },
};
</script>
<style lang="scss">
  .nosotros {
    overflow-x: hidden;
  }
  .main {
    background-color: $primary-color-dark;
    color: $white;
    padding: 4.5rem 1.5rem 9rem;

    @media screen and (min-width: $large) {
      padding: 6rem 1.5rem 10rem;
    }

    [class*='col-']:first-of-type {
      @media screen and (min-width: $xlarge) {
        max-width: 572px;
      }
    }
    .descripcion {
      @media screen and (min-width: 1400px) {
        font-size: 1.4rem;
      }
    }
  }

  .finalidad {
    background-color: $success-color-dark;
    background: linear-gradient(
      297.5deg, $success-color-dark 13.81%, $primary-color 83.57%);
    border-radius: .88rem;
    color: $white;
    margin: -7rem auto 6rem;
    min-width: 260px;
    max-width: 1116px;
    padding: 2.5rem 2.5rem 3rem;
    transition-property: background, padding;
    transition-duration: 1s;
    transition-timing-function: ease;
    width: 80%;

    @media screen and (min-width: $large) {
      background: linear-gradient(273.01deg, #038E50 0%, #007BFF 100%);
      padding: 2.5rem 1rem;
    }

    @media screen and (min-width: $xlarge) {
      padding: 2.5rem;
    }


    ul {
      list-style-type: none;
      margin-bottom: 0;

      @media screen and (min-width: $large) {
        display: flex;
        flex-flow: row wrap;
        gap: 1rem;
      }
    }

    .descripcion {
      display: flex;
      flex-flow: row wrap;
      gap: 1rem .8rem;

      @media screen and (min-width: $large) {
        flex: 1 1 auto;
        width: 30%;
      }

      .icon {
        color: #FFC044;
        flex: 1 1 40px;
        height: 40px;
        width: 40px;
      }
      p {
        flex: 2 1 72%;
        line-height: 1.3;
      }
    }
  }

  .desarrollado {
    padding: 0 2rem !important;

    .columnas {
      figure {
        text-align: center;
      }

      @media screen and (min-width: $large) {
        display: flex;
        flex-flow: column wrap;
        gap: 1rem 2rem;
        max-height: 500px;

        figure {
          flex: 1 1 40%;
          margin-bottom: 0;
          width: 40%;

          &:first-of-type {order: 1;}
          &:last-of-type {order: 2;}
        }
        div {
          flex: 1 1 55%;
          order: 3;
          width: 55%;
        }
      }
    }

    .membrete-caisert {
      height: clamp(40px, 100%, 86px);
      width: clamp(200px, 100%, 372px);
    }

    div {
      color: $gris-texto;
      font-size: 1.13rem;
    }

    .teamwork {
      min-width: 232px;
      width: 60%;

      @media screen and (min-width: $large) {
        max-width: 400px;
        width: 100%;
      }
    }
  }

  .green-waves {
    align-items: center;
    background: #BFEFD9;
    background: url('/../../img/vectores/waves-bg.svg') center/100% repeat-y;
    display: flex;
    flex-flow: row wrap;
    gap: 2rem;
    justify-content: center;
    padding: 2rem 1rem;

    & > div {
      @media screen and (min-width: $xlarge) {
        max-width: 600px;
        width: 50%;
      }
    }

    & > figure {
      max-width: 480px;
      width: 33.33%;
    }

    .subtitle {
      color: $gris-muted;
      font-size: 1.13rem;
      text-transform: uppercase;
    }
    header {
      font-size: 1.5rem;
      font-weight: 600;
      margin-bottom: 1rem;
    }
    p {
      color: $gris-texto;
      font-style: italic;
      line-height: 1.3;
    }
  }

  .our-services {
    align-items: center;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    padding-bottom: 3rem;

    @media screen and (min-width: $medium) {
      flex-direction: row;
      flex-wrap: wrap;
    }

    header:not(.h2-responsive) {
      font-size: 1.375rem;
      font-weight: 700;
      margin: -.25rem 0 .25rem;
      text-align: center;
      text-transform: uppercase;
    }

    p {
      color: $gris-muted;
      font-style: italic;
      line-height: 1.25;
    }
  }

  /* Estilos del svg Logo AMII */
  svg {
    width: 100%;
    height: 100%;
  }
  .fil0 {fill:none}
  .fil1 {fill:#ffffff}
  .str1 {stroke:#ffffff;stroke-width:6}
  .str0 {
    stroke:#ffffff;
    stroke-width:9;
    stroke-linecap:round;
    stroke-linejoin:round;
  }
  /* Fin estilos del svg */
  /* Animacion del logo */
  #nube {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
    animation: ani-nube 2s ease-in;
  }
  #punto1 {
    scale: 1;
    transform: scaleY(1);
    animation: ani-show .3s 6s, ani-pica 0.3s 7s linear alternate,
               ani-puntos 6s 10s linear alternate infinite;
    transform-origin: center 65%;
  }
  #punto2 {
    scale: 1;
    transform: scaleY(1);
    animation: ani-show .3s 6s, ani-puntos 6s 10s linear alternate infinite;
    transform-origin: center 65%;
  }
  #esteto {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
    animation: ani-esteto 4s linear;
  }
  #scopio {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
    animation: ani-scopio 4s ease-out;
  }
  @keyframes ani-nube {
    from {
      stroke-dashoffset: 1000;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
  @keyframes ani-esteto {
    0% {
      stroke-dashoffset: 1000;
    }
    50% {
      stroke-dashoffset: 1000;
    }
    70% {
      stroke-dashoffset: 0;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes ani-scopio {
    0% {
      stroke-dashoffset: 1000;
    }
    55% {
      stroke-dashoffset: 1000;
    }
    85% {
      stroke-dashoffset: 0;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes ani-show {
    from {
      opacity: 0;
    }
    to {
      opacity:1;
    }
  }
  @keyframes ani-puntos {
    0% {
      transform: scaleY(0.1);
    }
    5% {
      transform: scaleY(1);
    }
    100% {
      transform: scaleY(1);
    }
  }
  @keyframes ani-pica {
    from {
      transform: scaleY(0.1);
    }
    to {
      transform: scaleY(1);
    }
  }
  /* Fin animacion del logo */

/* Estilos del svg Encabezado */
[id|="vector"],
.main .descripcion,
.finalidad {
  animation-duration: .75s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-direction: forwards;
  animation-fill-mode: both;
}

#vector-asistente {
  animation-name: fadeInRight;
}
#vector-medico {
  animation-name: fadeInLeft;
  animation-delay: .45s;
}
#vector-integral {
  animation-name: fadeInDown;
  animation-delay: .75s;
}
#vector-inteligente {
  animation-name: fadeInUp;
  animation-delay: .75s;
}

.main .descripcion {
  animation-name: zoomIn;
  animation-delay: 1.5s;
}

.finalidad {
  animation-name: fadeInUp;
  animation-delay: 2s;
}
/* Fin animacion del Encabezado */

</style>
